// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gN","winCardBox":"gN","win-card-btn-detail":"gO","winCardBtnDetail":"gO","win-card-dec":"gP","winCardDec":"gP","win-card-name":"gQ","winCardName":"gQ"};